import { lazy } from 'react'

export const EatingPlaceV1 = lazy(() => import('./v1/EatingPlaceV1'))
